'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, n, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(n = 0; n < i.length; n++)r = i[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, n, o = {}, i = Object.keys(e);
    for(n = 0; n < i.length; n++)r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
}
const PaginationStep = renderWithRef('PaginationStep', null, (r, n)=>{
    var { children: o, active: i = false, disabled: c = false, accessibleText: p, as: a, component: s } = r;
    let b = _object_spread_props(_object_spread({
        'aria-label': null != p ? p : void 0
    }, _object_without_properties(r, [
        "children",
        "active",
        "disabled",
        "accessibleText",
        "as",
        "component"
    ])), {
        disabled: ('button' === a || 'button' === s) && c,
        as: c && 'button' !== a && 'button' !== s && 'span' || a || s || 'a',
        'aria-current': !!i
    }), l = new Set([
        'swan-pagination-step'
    ]);
    return c && l.add('swan-pagination-step-disabled'), i && l.add('swan-pagination-step-active'), jsx("li", {
        children: jsx(RenderComp, {
            root: "a",
            classNames: l,
            forwardedRef: n,
            props: b,
            children: o
        })
    });
});

export { PaginationStep };
